import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  // List of states
  states = [
    {'value':'AL', 'name':'Alabama'},
    {'value':'AK', 'name':'Alaska'},
    {'value':'AZ', 'name':'Arizona'},
    {'value':'AR', 'name':'Arkansas'},
    {'value':'CA', 'name':'California'},
    {'value':'CO', 'name':'Colorado'},
    {'value':'CT', 'name':'Connecticut'},
    {'value':'DE', 'name':'Delaware'},
    {'value':'DC', 'name':'District Of Columbia'},
    {'value':'FL', 'name':'Florida'},
    {'value':'GA', 'name':'Georgia'},
    {'value':'HI', 'name':'Hawaii'},
    {'value':'ID', 'name':'Idaho'},
    {'value':'IL', 'name':'Illinois'},
    {'value':'IN', 'name':'Indiana'},
    {'value':'IA', 'name':'Iowa'},
    {'value':'KS', 'name':'Kansas'},
    {'value':'KY', 'name':'Kentucky'},
    {'value':'LA', 'name':'Louisiana'},
    {'value':'ME', 'name':'Maine'},
    {'value':'MD', 'name':'Maryland'},
    {'value':'MA', 'name':'Massachusetts'},
    {'value':'MI', 'name':'Michigan'},
    {'value':'MN', 'name':'Minnesota'},
    {'value':'MS', 'name':'Mississippi'},
    {'value':'MO', 'name':'Missouri'},
    {'value':'MT', 'name':'Montana'},
    {'value':'NE', 'name':'Nebraska'},
    {'value':'NV', 'name':'Nevada'},
    {'value':'NH', 'name':'New Hampshire'},
    {'value':'NJ', 'name':'New Jersey'},
    {'value':'NM', 'name':'New Mexico'},
    {'value':'NY', 'name':'New York'},
    {'value':'NC', 'name':'North Carolina'},
    {'value':'ND', 'name':'North Dakota'},
    {'value':'OH', 'name':'Ohio'},
    {'value':'OK', 'name':'Oklahoma'},
    {'value':'OR', 'name':'Oregon'},
    {'value':'PA', 'name':'Pennsylvania'},
    {'value':'RI', 'name':'Rhode Island'},
    {'value':'SC', 'name':'South Carolina'},
    {'value':'SD', 'name':'South Dakota'},
    {'value':'TN', 'name':'Tennessee'},
    {'value':'TX', 'name':'Texas'},
    {'value':'UT', 'name':'Utah'},
    {'value':'VT', 'name':'Vermont'},
    {'value':'VA', 'name':'Virginia'},
    {'value':'WA', 'name':'Washington'},
    {'value':'WV', 'name':'West Virginia'},
    {'value':'WI', 'name':'Wisconsin'},
    {'value':'WY', 'name':'Wyoming'}
  ];
  markerImages = [
    'https://i.imgur.com/NYLBjFr.png',
    'https://i.imgur.com/3O2PzY5.png',
    'https://i.imgur.com/8RXMxAE.png',
  ];

  month = new Array();

  constructor() {
    this.month[0] = 12;
    this.month[1] = 1;
    this.month[2] = 2;
    this.month[3] = 3;
    this.month[4] = 4;
    this.month[5] = 5;
    this.month[6] = 6;
    this.month[7] = 7;
    this.month[8] = 8;
    this.month[9] = 9;
    this.month[10] = 10;
    this.month[11] = 11;
  }

  getStateName(value: string): string{
    let stateName = '';
    this.states.map((state) => {
      if(state.value === value)
        stateName = state.name;
    });
    return stateName;
  }

  // isNumber() - Check that entered character is character or not
  isNumber(evt): boolean {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // getValAccordingToZoomLevel() - Get moving value of map according to zoom level
  getValAccordingToZoomLevel(zoomLevel: number):number{
    let val = 0.0010000;
    switch (zoomLevel) {
    case 16:
      val = 0.0010000;
      break;
    case 15:
      val = 0.0030000;
      break;
    case 14:
      val = 0.0065000;
      break;
    case 13:
      val = 0.0090000;
      break;
    case 12:
      val = 0.0150000;
      break;
    case 11:
      val = 0.0290000;
      break;
    case 10:
      val = 0.0545000;
      break;
    case 9:
      val = 0.1000000;
      break;
    case 8:
      val = 0.2200000;
      break;
    case 7:
      val = 0.5800000;
      break;
    case 6:
      val = 0.9000000;
      break;
    case 5:
      val = 1.1000000;
      break;
    case 4:
      val = 2.5000000;
      break;
    case 3:
      val = 5.0000000;
      break;
    case 2:
      val = 8.0000000;
      break;
    case 1:
      val = 9.9999999;
      break;
    default:
      val = 0.0005000;
      break;
    }
    return val;
  }

  // preventClick() - Prevent click event of selecting row
  preventClick(event): void {
    event.stopPropagation();
  }

  // _imageEncode() - Encode image from base64.
  _imageEncode (arrayBuffer): any {
    let b64encoded = btoa([].reduce.call(new Uint8Array(arrayBuffer), function(p, c){return p+String.fromCharCode(c);}, ''));
    let mimetype= 'image/jpeg';
    return 'data:'+ mimetype + ';base64,' + b64encoded;
  }
}
